import PortalDocument from "./PortalDocument";
import AbstractContainer from "./AbstractContainer";
import ViewerType from "./DataType";
import MimeTypes from "./mimetype/MimeTypes";
import Exception from "../../shared/exception/Exception";
import Translate from "../../shared/translation/Translate";
import {Base64} from "js-base64";
import FunctionHelper from "../../shared/helper/FunctionHelper";
import {Attachment} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";

const urlCreator = FunctionHelper.applyValue(window.URL, window.webkitURL);

export default class ImageContainer extends AbstractContainer {
	private loadingTask?: Promise<string>;

	public clean(): void {
		if (this.loaded) {
			urlCreator.revokeObjectURL(this.data);
		}

		if (FunctionHelper.exists(this.loadingTask)) {
			this.loadingTask = undefined;
		}

		this.data = undefined;
		this.loaded = false;
	}

	public async loadViewerData(portalDocument: PortalDocument, attachment?: Attachment): Promise<string> {
		if (!FunctionHelper.exists(this.data)) {
			throw new Exception(Translate.value("errors.files.corrupt", {ns: "message"}));
		}

		if (FunctionHelper.exists(this.loadingTask)) {
			return this.loadingTask!;
		}

		if (this.loaded) {
			return this.data;
		}

		let url: string = "";
		switch (portalDocument.getMimeType(attachment)) {
			case MimeTypes.SVG:
				let svgData: string = new XMLSerializer().serializeToString(
					new DOMParser().parseFromString(
						new TextDecoder().decode(this.data), "image/svg+xml"
					)
				);

				url = "data:image/svg+xml;base64," + Base64.toBase64(svgData);
				break;
			default:
				url = urlCreator.createObjectURL(new Blob([this.data]));
				break;
		}

		this.loadingTask = new Promise<string>((resolve, reject) => {
			let loadingImage: HTMLImageElement = new Image();

			loadingImage.onload = () => {
				this.loaded = true;
				resolve(url);
			};

			loadingImage.onerror = (event: Event | string) => {
				reject(event);
			};

			loadingImage.src = url;
		});

		try {
			this.data = await this.loadingTask;
			this.loaded = true;
		} catch (exception: any) {
			let portalException: Exception = new Exception(Translate.value("errors.files.load", {ns: "message"}));
			portalException.originalException = exception;
			throw portalException;
		}

		return this.loadingTask;
	}

	public async getNumberOfPages() {
		return 1;
	}

	public getType(): ViewerType {
		return ViewerType.IMAGE;
	}
}